import path from 'ramda/src/path'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId }) => path(
	[moduleId, 'hideEmptyTabs'], moduleDescriptions,
)
